import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import TransferInTrackingReportActions, {
  TransferInTrackingReportTypes
} from '../Stores/TransferInTrackingReport/Actions';

const getAppStore = state => state.app;

export function* transferInTrackingReportInitTransferInTracking() {
  try {
    yield put(TransferInTrackingReportActions.transferInTrackingReportReportLoading(true));

    const app = yield select(getAppStore);
    const getData = {};

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `stkTrfReport/initTransferInTracking/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      yield put(
        TransferInTrackingReportActions.transferInTrackingReportInitTransferInTrackingSuccess(
          result.data
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(TransferInTrackingReportActions.transferInTrackingReportReportLoading(false));
  }
}

export function* transferInTrackingReportTransferInTracking({ formikBag, criteria }) {
  try {
    formikBag.setSubmitting(true);
    yield put(TransferInTrackingReportActions.transferInTrackingReportReportLoading(true));

    const objCriteria = {};
    if ('start_date' in criteria) {
      objCriteria.start_date = criteria.start_date;
    }
    if ('end_date' in criteria) {
      objCriteria.end_date = criteria.end_date;
    }
    if ('division_ids_select2' in criteria) {
      const values = criteria.division_ids_select2;
      if (values !== null && values.length > 0) {
        objCriteria.division_ids = values.map(entry => {
          return entry.value;
        });
      }
    }
    if ('fr_location_ids_select2' in criteria) {
      const values = criteria.fr_location_ids_select2;
      if (values !== null && values.length > 0) {
        objCriteria.fr_location_ids = values.map(entry => {
          return entry.value;
        });
      }
    }

    let columns = [];
    if (criteria.columns.target.length > 0) {
      columns = criteria.columns.target.map(entry => {
        return entry.column;
      });
    }

    const app = yield select(getAppStore);
    const postData = {
      sorts: [],
      criteria: objCriteria,
      columns
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `stkTrfReport/transferInTracking/${app.curSiteFlowId}`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(
        TransferInTrackingReportActions.transferInTrackingReportTransferInTrackingSuccess(
          criteria,
          result.data.data
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    formikBag.setSubmitting(false);
    yield put(TransferInTrackingReportActions.transferInTrackingReportReportLoading(false));
  }
}

export function* transferInTrackingReportFetchDivisionOptions({ search }) {
  try {
    yield put(
      TransferInTrackingReportActions.transferInTrackingReportFetchDivisionOptionLoading(true)
    );

    const app = yield select(getAppStore);
    const postData = {
      search,
      filters: []
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `division/select2`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      const options = result.data.data.map(d => ({
        value: d.id,
        label: `${d.code} ${d.name_01}`
      }));

      yield put(
        TransferInTrackingReportActions.transferInTrackingReportFetchDivisionOptionSuccess(options)
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(
      TransferInTrackingReportActions.transferInTrackingReportFetchDivisionOptionLoading(false)
    );
  }
}

export function* transferInTrackingReportFetchFrLocationOptions({ search }) {
  try {
    yield put(
      TransferInTrackingReportActions.transferInTrackingReportFetchFrLocationOptionLoading(true)
    );

    const app = yield select(getAppStore);
    const postData = {
      search,
      filters: []
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `location/select2`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      const options = result.data.data.map(d => ({
        value: d.id,
        label: `${d.code} ${d.desc_01}`
      }));

      yield put(
        TransferInTrackingReportActions.transferInTrackingReportFetchFrLocationOptionSuccess(
          options
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(
      TransferInTrackingReportActions.transferInTrackingReportFetchFrLocationOptionLoading(false)
    );
  }
}

export const saga = [
  takeLatest(
    TransferInTrackingReportTypes.TRANSFER_IN_TRACKING_REPORT_INIT_TRANSFER_IN_TRACKING,
    transferInTrackingReportInitTransferInTracking
  ),
  takeLatest(
    TransferInTrackingReportTypes.TRANSFER_IN_TRACKING_REPORT_TRANSFER_IN_TRACKING,
    transferInTrackingReportTransferInTracking
  ),

  takeLatest(
    TransferInTrackingReportTypes.TRANSFER_IN_TRACKING_REPORT_FETCH_DIVISION_OPTIONS,
    transferInTrackingReportFetchDivisionOptions
  ),

  takeLatest(
    TransferInTrackingReportTypes.TRANSFER_IN_TRACKING_REPORT_FETCH_FR_LOCATION_OPTIONS,
    transferInTrackingReportFetchFrLocationOptions
  )
];
